import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ArchiveJob, ArchiveJobStatus } from '../../../../models/archive-job.model';
import { ArchiveJobManager } from '../../../../managers/archive-job.manager';
import { BaseComponent } from "../../../base.component";

@Component({
    selector: 'lex-edit-archive',
    templateUrl: './edit-archive.component.html',
    styleUrls: ['./edit-archive.component.scss'],
    standalone: false
})
export class EditArchiveComponent extends BaseComponent implements OnInit {
    public numberOfDigits: number[] = [7, 8, 9, 10];
    public archiveTypes = [{
        value: false,
        displayName: 'Standard'
    }, {
        value: true,
        displayName: 'Standard plus TIFF'
    }]
    public archiveJob: ArchiveJob;
    public archiveJobFormGroup: FormGroup;

    constructor(private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private archiveJobManager: ArchiveJobManager,
        private router: Router,
        private matSnackBar: MatSnackBar
    ) {
        super();
        this.archiveJobManager.currentArchiveJob$
            .pipe(takeUntil(this.destroy$))
            .subscribe((archiveJob) => {
                this.archiveJob = archiveJob;
                if (archiveJob) {
                    this.initializeForm(archiveJob);
                }
            });
    }

    ngOnInit(): void {
        this.archiveJobManager.setCurrentArchiveJob(this.activatedRoute.snapshot.params?.id);
    }

    private initializeForm(archiveJob: ArchiveJob): void {
        this.archiveJobFormGroup = this.fb.group({
            title: [archiveJob.title, [Validators.required]],
			comments: [archiveJob.comments],
			archiveBaseNumberStart: [archiveJob.archiveBaseNumberStart, [Validators.required, Validators.maxLength(10), Validators.pattern("^[0-9]*$")]],
            archiveBaseNumberDigits: [archiveJob.archiveBaseNumberDigits, [Validators.required]],
            isCreateTiff: [archiveJob.isCreateTiff, [Validators.required]],
		});

		if (archiveJob.status === ArchiveJobStatus.Queued || archiveJob.status === ArchiveJobStatus.Running || archiveJob.status === ArchiveJobStatus.PostRun) {
			this.archiveJobFormGroup.controls["archiveBaseNumberStart"].disable();
			this.archiveJobFormGroup.controls["archiveBaseNumberDigits"].disable();
			this.archiveJobFormGroup.controls["isCreateTiff"].disable();
		}

        this.archiveJobFormGroup.valueChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe((newValue) => {
                this.archiveJob.title = newValue.title;
				this.archiveJob.comments = newValue.comments;
				if (!this.archiveJobFormGroup.controls["archiveBaseNumberStart"].disabled)
					this.archiveJob.archiveBaseNumberStart = newValue.archiveBaseNumberStart;
				if (!this.archiveJobFormGroup.controls["archiveBaseNumberDigits"].disabled)
					this.archiveJob.archiveBaseNumberDigits = newValue.archiveBaseNumberDigits;
				if (!this.archiveJobFormGroup.controls["isCreateTiff"].disabled)
					this.archiveJob.isCreateTiff = newValue.isCreateTiff;
            });
    }

    public isSaveDisabled(): boolean {
        return this.archiveJobFormGroup.invalid || this.archiveJobFormGroup.pristine;
    }

    public save(): void {
        this.archiveJobManager.saveArchiveJob(this.archiveJob).subscribe(() => {
            this.matSnackBar.open('ArchiveJob saved successfully', 'X', {
                duration: 3000
            });
            this.router.navigate(['/', 'account', 'archive-jobs']);
        });
    }

    public cancel(): void {
        this.router.navigate(['/', 'account', 'archive-jobs']);
    }

    public viewDocuments(): void {
        this.router.navigate(['/', 'review', 'browse'], {
            queryParams: {ArchiveJobId: this.archiveJob.archiveJobId}
        });
    }
}
